const COLORS_EVEN = [
  '#6ECDD3', // First color
  '#55676F',
  '#E3AB19',
  '#C01E2E', // red
  '#B39C7C',
  '#7EAEB4',
  '#F2E297', // yellow
  
  '#E3AB19',
  '#55676F',
  '#F2E297', // yellow
  '#7EAEB4',
  '#B39C7C',
  '#C01E2E', // red
];

/*const COLORS_ODD = [
  '#6ECDD3', // First color
  '#55676F',
  '#E3AB19',
  '#C01E2E', 
  '#B39C7C',
  '#7EAEB4',
  '#F2E297',
  
  '#55676F',
  '#E3AB19',
  '#C01E2E',
  '#B39C7C',
  '#7EAEB4',
  '#F2E297',
];*/

const colors = {
  odd: COLORS_EVEN,
  even: COLORS_EVEN,
};

export default colors;
